import { ReactComponent as MenuIcon } from "../../assets/svg/menu.svg";
import { useLanguage } from "../../hooks/use-language";
import { useMenu } from "../../hooks/use-menu";

import styles from "./menu-button.module.css";

export function MenuButton() {
  const { dictionary } = useLanguage();
  const { menuState, toggleMenu } = useMenu();

  return (
    <button
      onClick={toggleMenu}
      className={styles.button}
      aria-label={dictionary.menu}
      type="button"
    >
      <MenuIcon
        title={dictionary.menu}
        width={48}
        height={48}
        className={`${styles[menuState]}`}
      />
    </button>
  );
}
